class GiftWrapping extends HTMLElement {
  constructor() {
    super();

    this.giftWrapProductId = this.dataset.giftWrapId;
    this.giftWrapPrice = parseInt(this.dataset.giftWrapPrice) || 0;
    this.isGiftWrappingEnabled = this.dataset.giftWrapping;
    this.cartItemCount = parseInt(this.getAttribute('cart-items-size'));
    this.giftWrapItemCount = parseInt(this.getAttribute('gift-wraps-in-cart'));
    this.totalItemCount = parseInt(this.getAttribute('items-in-cart'));
    this.giftWrapMode = this.dataset.giftWrappingLimit;
  }

  connectedCallback() {
    this.initializeGiftWrapCheckbox();
    this.handleInitialGiftWrapState();
    this.updateAddOnDisplay();
  }

  initializeGiftWrapCheckbox() {
    this.querySelector('[name="attributes[gift-wrapping]"]').addEventListener('change', (event) => {
      event.target.checked ? this.addGiftWrap() : this.removeGiftWrap();
    });
  }

  handleInitialGiftWrapState() {
    // If the only item left in cart is the gift wrap itself, remove it
    if (this.cartItemCount == 1 && this.giftWrapItemCount > 0) {
      return this.removeGiftWrap();
    }
    // Attribute says gift wrap is off but a wrap item is still in cart — remove it
    if (this.giftWrapItemCount > 0 && this.isGiftWrappingEnabled.length == 0) {
      return this.syncGiftWrapQuantity();
    }
    // Attribute says gift wrap is on but no wrap item in cart — add it
    if (this.giftWrapItemCount == 0 && this.isGiftWrappingEnabled.length > 0) {
      return this.addGiftWrap();
    }
    // Gift wrap is in cart but quantity is wrong (should always be 1 per order)
    if (this.giftWrapItemCount > 0 && this.giftWrapItemCount !== 1) {
      return this.syncGiftWrapQuantity();
    }
  }

  updateAddOnDisplay() {
    const addOnDisplay = this.querySelector('.gift-wrap-addon-display');
    if (!addOnDisplay) return;

    const checkbox = this.querySelector('[name="attributes[gift-wrapping]"]');
    const isChecked = checkbox && checkbox.checked;
    
    if (isChecked && this.totalItemCount > 0) {
      addOnDisplay.classList.remove('hidden');
      const qtyEl = addOnDisplay.querySelector('[data-gift-wrap-qty]');
      const totalEl = addOnDisplay.querySelector('[data-gift-wrap-total]');
      
      // Gift wrap is charged once per order — always quantity 1
      if (qtyEl) qtyEl.textContent = 1;
      if (totalEl) {
        totalEl.textContent = this.formatMoney(this.giftWrapPrice);
      }
    } else {
      addOnDisplay.classList.add('hidden');
    }
  }

  formatMoney(cents) {
    return 'R' + (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  addGiftWrap() {
    this.showLoader();
    const sectionsToUpdate = this.getSectionsToUpdate();
    // Always add exactly 1 gift wrap per order, regardless of item count
    const requestBody = this.createRequestBody(
      {
        [this.giftWrapProductId]: 1,
      },
      { 'gift-wrapping': true },
      sectionsToUpdate
    );
    this.updateCart(requestBody);
  }

  syncGiftWrapQuantity() {
    this.showLoader();
    const sectionsToUpdate = this.getSectionsToUpdate();
    // Sync to 1 per order — used to correct stale per-item quantities
    const requestBody = this.createRequestBody(
      {
        [this.giftWrapProductId]: 1,
      },
      { 'gift-wrapping': true },
      sectionsToUpdate
    );
    this.updateCart(requestBody);
  }

  removeGiftWrap() {
    this.showLoader();
    const sectionsToUpdate = this.getSectionsToUpdate();
    const requestBody = this.createRequestBody(
      {
        [this.giftWrapProductId]: 0,
      },
      { 'gift-wrapping': '', 'gift-note': '' },
      sectionsToUpdate
    );
    this.updateCart(requestBody);
  }

  getSectionsToUpdate() {
    let sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    return sections;
  }

  createRequestBody(updates, attributes, sections) {
    return JSON.stringify({ updates, attributes, sections });
  }

  updateCart(body) {
    fetch(`${FoxTheme.routes.cart_update_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body } })
      .then((response) => response.json())
      .then((parsedState) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: parsedState });
      })
      .catch((error) => {
        console.error('Error updating cart:', error);
      });
  }

  showLoader() {
    const loaderElement = this.querySelector('.loader');
    if (loaderElement) loaderElement.classList.add('btn--loading');
  }
}
customElements.define('gift-wrapping', GiftWrapping);

class GiftNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', FoxTheme.utils.debounce(this.updateGiftNote.bind(this), 300));
  }

  updateGiftNote(event) {
    const requestBody = JSON.stringify({ attributes: { 'gift-note': event.target.value } });
    fetch(`${FoxTheme.routes.cart_update_url}`, { ...FoxTheme.utils.fetchConfig(), ...{ body: requestBody } });
  }
}
customElements.define('gift-note', GiftNote);

class RemoveGiftWrapButton extends HTMLAnchorElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();

      const cartItemsElement = this.closest('cart-items');
      if (cartItemsElement) {
        cartItemsElement.showLoader(this.dataset.index);
      }

      const giftWrappingElement = document.querySelector('gift-wrapping');
      if (giftWrappingElement) {
        giftWrappingElement.removeGiftWrap();
      }
    });
  }
}
customElements.define('gift-wrap-remove-item', RemoveGiftWrapButton, { extends: 'a' });